import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { InstagramHashtag } from 'src/app/models/latest-aggregate-amounts.model'
import {
  getInstagramHashtag,
  getLoading,
} from 'src/app/selectors/latest-aggregate-amounts.selector'
import {
  getDataCollectByInstagramHashtag,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-instagram-hashtag-count',
    templateUrl: './aggregated-amounts-instagram-hashtag-count.component.html',
    styleUrls: ['./aggregated-amounts-instagram-hashtag-count.component.scss'],
    standalone: false
})
export class AggregatedAmountsInstagramHashtagCountComponent implements OnInit {
  instagramHashtagCountModel$: Observable<InstagramHashtag>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.instagramHashtagCountModel$ = this.store.select(getInstagramHashtag)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByInstagramHashtag)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
